import { Check, ChevronsUpDown } from 'lucide-react';
import { useState } from 'react';

import { cn } from '~shared/shadcn/lib/utils';
import { Button } from '~shared/shadcn/ui/button';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '~shared/shadcn/ui/command';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~shared/shadcn/ui/popover';

export function FamilyNameFilter({
  familyNames,
  value,
  onValueChange,
}: {
  value: string;
  onValueChange: React.Dispatch<React.SetStateAction<string>>;
  familyNames: Array<string>;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant='outline'
          role='combobox'
          aria-expanded={open}
          className='w-[200px] justify-between capitalize'
        >
          {value
            ? familyNames.find((familyName) => familyName === value)
            : 'Family Names'}
          <ChevronsUpDown className='opacity-50' />
        </Button>
      </PopoverTrigger>
      <PopoverContent className='w-[200px] p-0'>
        <Command>
          <CommandInput placeholder='Search family name...' />
          <CommandList>
            <CommandEmpty>No family name found.</CommandEmpty>
            <CommandGroup>
              {familyNames.map((familyName) => (
                <CommandItem
                  key={familyName}
                  value={familyName}
                  onSelect={(currentValue) => {
                    onValueChange(currentValue === value ? '' : currentValue);
                    setOpen(false);
                  }}
                  className='capitalize'
                >
                  {familyName}
                  <Check
                    className={cn(
                      'ml-auto',
                      value === familyName ? 'opacity-100' : 'opacity-0',
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
